module.exports = __webpack_public_path__ + "static/nalu-db73fb50eb6fe6a067ccef4050ac8358.jpeg";